/**
 * Reads the duration of a local video File (or Blob) using the browser's
 * HTML5 video metadata loader. Works for MP4 / MOV / INSV (INSV files use
 * standard MP4 container atoms; browsers handle them via the MP4 demuxer).
 *
 * Resolves to a positive seconds value on success, or 0 if the browser
 * cannot decode the file or returns a non-finite duration. Never rejects —
 * callers always get a number they can send to the API.
 *
 * Server-side: zero means "browser couldn't measure" and the API falls
 * back to the worker's ffmpeg probe value for subscription billing.
 */
export async function getVideoDurationSeconds(file) {
  if (!file) return 0;

  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;
    video.src = URL.createObjectURL(file);

    const cleanup = () => {
      try { URL.revokeObjectURL(video.src); } catch { /* noop */ }
    };

    video.onloadedmetadata = () => {
      const seconds = Number.isFinite(video.duration) && video.duration > 0
        ? video.duration
        : 0;
      cleanup();
      resolve(seconds);
    };

    video.onerror = () => {
      cleanup();
      resolve(0);
    };
  });
}
